import React, { JSX } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import LzMCrud from './Crud';
import { LzTThemeColor } from '@lz/app/Theming/types';
import { lzFSortByPosition } from '@lz/services/Utils';

export type LzTCrudListGroupActionIconGroup = {
  [key: string]: LzMCrudListGroupActionIcon;
};

export interface LzNCrudListGroupActionIcon {
  route?: string;
  title: string;
  icon: JSX.Element;
  color: LzTThemeColor;
  confirmation: string;
  checksNotRequiredToShow?: boolean;
  sortOrder?: number;
}

class LzMCrudListGroupActionIcon implements LzNCrudListGroupActionIcon {
  route: string;
  title: string;
  icon: JSX.Element;
  color: LzTThemeColor;
  confirmation: string;
  checksNotRequiredToShow: boolean;
  sortOrder: number;

  constructor(model: LzNCrudListGroupActionIcon) {
    this.route = model.route || '';
    this.title = model.title || '';
    this.icon = model.icon;
    this.color = model.color || '';
    this.confirmation = model.confirmation || '';
    this.checksNotRequiredToShow = !!model.checksNotRequiredToShow;
    this.sortOrder = +(model.sortOrder || 1);
  }

  static parseData(data: any, crud: LzMCrud): LzTCrudListGroupActionIconGroup {
    const out: LzTCrudListGroupActionIconGroup = {};

    if (!crud || crud.noGroupActions) {
      return out;
    }

    if (!data) {
      data = {};
    }

    const keys = Object.keys(data);
    for (const key of keys) {
      out[key] = new LzMCrudListGroupActionIcon(data[key]);
    }

    // Now add based on crud settings
    if (crud.showStatusGroupAction && !out.status_active) {
      out.status_active = new LzMCrudListGroupActionIcon({
        title: 'Activate Selected',
        icon: <CheckIcon />,
        color: 'success',
        confirmation: 'Are you sure you want to activate all selected records?',
        sortOrder: 50,
      });
    }
    if (crud.showStatusGroupAction && !out.status_inactive) {
      out.status_inactive = new LzMCrudListGroupActionIcon({
        title: 'De-Activate Selected',
        icon: <CloseIcon />,
        color: 'warning',
        confirmation:
          'Are you sure you want to de-activate all selected records?',
        sortOrder: 60,
      });
    }
    if (crud.showDeleteGroupAction && !out.delete) {
      out.delete = new LzMCrudListGroupActionIcon({
        title: 'Delete Selected',
        icon: <DeleteIcon />,
        color: 'error',
        confirmation: 'Are you sure you want to delete all selected records?',
        sortOrder: 70,
      });
    }

    return lzFSortByPosition(out, 'sortOrder');
  }
}

export default LzMCrudListGroupActionIcon;
